import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import axiosInstance from "../services/axiosInstance";
import { OrderStatusEnum } from "../enums/OrderEnum";
import ViewSheetPopup from "../Popup/viewSheetPopup";
import CheckoutPopup from "../Popup/checkoutPopup";
import { PropagateLoader } from "react-spinners";
import CheckinPopup from "../Popup/checkinPopup";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      textAlign: "left",
      padding: "15px",
      opacity: "1",
      "@media screen and (min-width: 1250px)niu and (max-width: 1600px)": {
        fontSize: "14px",
      },
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5)",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px 8px",
      },
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px",
      },
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month}.${year} | ${hours}:${minutes}`;
};

const DriverInBoxTable = ({ searchTerm }) => {
  const [openCheckOutPopup, setOpenCheckOutPopup] = useState(false);
  const [openCheckInPopup, setOpenCheckInPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleCloseCheckOutPopup = () => setOpenCheckOutPopup(false);
  const HandleCloseCheckInPopup = () => setOpenCheckInPopup(false);

  const columns = [
    {
      name: "Praxis",
      selector: (row) => row.dentistName,
      sortable: true,
      sortFunction: (a, b) => a.dentistName.localeCompare(b.dentistName),
    },
    {
      name: "Patient",
      selector: (row) => row.patientName,
      sortable: true,
      sortFunction: (a, b) => a.patientName.localeCompare(b.patientName),
    },
  ];

  const handleRowClick = (row) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some((r) => r.id === row.id);
      if (isSelected) {
        return prevSelectedRows.filter((r) => r.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  const isRowSelected = (row) => {
    return selectedRows.some((r) => r.id === row.id);
  };

  useEffect(() => {
    fetchDriverInBoxOrders();
  }, []);

  const fetchDriverInBoxOrders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/api/order/getPPOrders/${OrderStatusEnum.Transferred_To_Driver}`
      );
      if (response) {
        if (Array.isArray(response)) {
          const mappedOrders = response.map((order) => {
            return {
              id: order.orderId,
              dentistName: order.dentistName || "",
              patientName: order.patientName,
              workTypeName: order.workTypeName,
              orderStatusId: order.orderStatusId,
              orderTypeId: order.orderTypeId,
              finalDelivery: formatDueDeliveryDate(order.deliveryDate),
              finalDeliveryRaw: order.deliveryDate, // Store raw date for sorting
              dueDelivery: formatDueDeliveryDate(order.dueDeliveryDate),
              timeStamp: formatDueDeliveryDate(order.checkoutDate),
              timeStampRaw: order.checkoutDate, // Store raw date for sorting
              isDue:
                new Date(order.deliveryDate) < new Date(order.checkoutDate),
              create: "",
            };
          });

          setOrders(mappedOrders);
          setSelectedRows([]);
        } else {
          setOrders([]);
          setSelectedRows([]);
        }
      } else {
        setOrders([]);
        setSelectedRows([]);
      }
    } catch (error) {
      setOrders([]);
      setSelectedRows([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = React.useMemo(() => {
    const clonedOrders = [...orders];
    return clonedOrders.filter(
      (order) =>
        order.dentistName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.patientName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [orders, searchTerm]);

  const handleCheckOutOrder = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post(
        "/api/order/postCheckOutOrders",
        {
          ids: selectedIds,
        }
      );

      if (response.isSuccess) {
        setOpenCheckOutPopup(true);
        await fetchDriverInBoxOrders();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  const handleCheckInOrder = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post("/api/order/PostCheckedIn", {
        ids: selectedIds,
      });
      if (response.isSuccess) {
        setOpenCheckInPopup(true);
        await fetchDriverInBoxOrders();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  return (
    <div>
      <div>
        {loading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DataTable
              defaultSortFieldId="finalDeliveryDate"
              defaultSortAsc={true}
              noDataComponent={
                <div className="py-4 text-gray-500">
                  Es sind keine Datensätze zum Anzeigen vorhanden
                </div>
              }
              className=" mt-7 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
              scrollable
              scrollHeight="600px"
              columns={columns}
              data={filteredOrders}
              pagination={false}
              fixedHeader
              customStyles={customStyles}
              sortIcon={<SortIcon />}
              highlightOnHover={false}
              onRowClicked={handleRowClick}
              conditionalRowStyles={[
                {
                  when: (row) => row.isDue,
                  style: {
                    backgroundColor: "#FE725C33",
                    color: "#828282",
                  },
                },
                {
                  when: (row) => isRowSelected(row),
                  style: {
                    backgroundColor: "#cce5ff",
                    color: "#004085",
                  },
                },
              ]}
            />
            <div
              className="flex justify-end items-end gap-2"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="text-end mt-4">
                <button
                  className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white
                              font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in disabled:opacity-50 disabled:cursor-not-allowed`}
                  type="button"
                  disabled={selectedRows && selectedRows.length === 0}
                  onClick={() => {
                    handleCheckInOrder();
                  }}
                >
                  CHECK In
                </button>
              </div>
              <div className="text-end mt-4">
                <button
                  className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border border-blue hover:bg-blue-800 hover:border-blue-800 text-white
                              font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in disabled:opacity-50 disabled:cursor-not-allowed`}
                  type="button"
                  disabled={selectedRows && selectedRows.length === 0}
                  onClick={() => {
                    handleCheckOutOrder();
                  }}
                >
                  CHECK OUT
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      {/* modal popup */}
      <ViewSheetPopup openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <CheckoutPopup
        openPopUp={openCheckOutPopup}
        closePopUp={HandleCloseCheckOutPopup}
      />

      <CheckinPopup
        openPopUp={openCheckInPopup}
        closePopUp={HandleCloseCheckInPopup}
      />
    </div>
  );
};

export default DriverInBoxTable;
